import React, { useState } from 'react';
import { useTheme } from '../../ThemeContext';

const Navbar = ({ sections, onSectionClick }) => {
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';
  const [activeTab, setActiveTab] = useState(sections[0]); // Track the active tab

  return (
    <nav
      className={`flex flex-wrap justify-center items-center px-4 py-2 md:px-8 lg:px-16 transition-all duration-300 ${
        isDarkMode ? 'bg-gradient-to-r from-gray-800 to-gray-900 text-white' : 'bg-white text-gray-700'
      } shadow-lg`}
    >


      {/* Navigation Links */}
      <div className="flex flex-wrap justify-center w-full md:w-auto space-x-4">
        {sections.map((section, index) => (
          <a
            key={index}
            href="#"
            className={`px-4 py-2 rounded-lg text-sm md:text-base font-medium capitalize transition-all duration-300 ${
              section === activeTab
                ? isDarkMode
                  ? 'bg-gray-700 text-white'
                  : 'bg-blue-700 text-white'
                : isDarkMode
                ? 'text-gray-300 hover:text-white hover:bg-gray-800'
                : 'text-gray-700 hover:bg-blue-500 hover:text-gray-100'
            }`}
            onClick={(e) => {
              e.preventDefault(); // Prevent default link behavior
              setActiveTab(section); // Update the active tab
              onSectionClick(section); // Handle the section click
            }}
          >
            {section}
          </a>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;
